module.exports = "js/webpack/cbca3e305b7b982c0745344c6951285c.svg";